import React from 'react'
import PatientProfileAddOns from '../../other/patient/PatientProfileAddOns'
import PatientInfoHeader from '../../other/patient/PatientInfoHeader'

export default function WhatsAppChatHeader(props) {
  const { patient, layout, patientMessages } = props

  return (
    <>
      <PatientProfileAddOns
        btnClasses="text-primary bg-transparent border-0 font-size-20 py-0"
        wrapperClasses="justify-content-between p-3"
        isPopUp={true}
        type="whatsapp"
        patient={patient}
      />
      <PatientInfoHeader patient={patient} patientMessages={patientMessages} layout={layout} />
    </>
  )
}
